import { apiClient } from "@/lib/api-client";
import type {
  JoinWhatsappGroupsBody,
  JoinWhatsappGroupsResp,
  WhatsappPickerGroupsResp,
} from "@/types/whatsappGroups.ts";
import { queryOptions } from "@tanstack/react-query";

/** The "add okthx to your groups" picker's requests, for web and native alike. */
export const whatsappPickerGroupsQueryKey = ["whatsappPickerGroups"] as const;

/** The groups the user administers, and which already have okthx. */
export const whatsappPickerGroupsQueryOptions = () =>
  queryOptions({
    queryKey: whatsappPickerGroupsQueryKey,
    queryFn: async ({ signal }) => {
      const res = await apiClient.get<WhatsappPickerGroupsResp>(
        "/api/a/connectors/whatsapp-sync/groups",
        { signal },
      );
      return res.data;
    },
    // A 404 or 409 is the answer (not linked, session not live), not a blip.
    retry: false,
    // Each read is a live query from the user's own WhatsApp; the picker
    // refreshes after a join, and focus alone shouldn't add wire traffic.
    refetchOnWindowFocus: false,
    // The dialog reads the list to decide whether to open, then its form
    // mounts on the same key; without this the form's mount reads it again.
    staleTime: 30_000,
  });

/** Queue okthx joining `groupIds`; answers how many it will actually join. */
export const joinWhatsappGroups = async (body: JoinWhatsappGroupsBody) => {
  const res = await apiClient.post<JoinWhatsappGroupsResp>(
    "/api/a/connectors/whatsapp-sync/groups/join",
    body,
  );
  return res.data;
};
